import { joinString } from '../../../utils/updateDeep';

export const getFullAdress = location =>
  joinString(
    [
      location.address,
      location.city,
      joinString([location.state, location.zip], ' '),
    ],
    ', ',
  );



// WEBPACK FOOTER //
// ./src/components/AppointmentForm/helpers/getFullLocationAdress.js